import { BRAND } from '@/brand/brandConfig';

export type LogoVariant = 'horizontal' | 'compact' | 'icon';
export type LogoSurface = 'light' | 'dark';

interface Props {
  /** 'horizontal' = full lockup (mark + wordmark + tagline), 'compact' = the same lockup at a smaller footprint for tight headers, 'icon' = mark only. */
  variant?: LogoVariant;
  /** Which background this renders on, so contrast stays correct. */
  surface?: LogoSurface;
  className?: string;
}

/** Renders the FitMap brand mark from the real logo assets in public/brand/. */
export function FitMapLogo({ variant = 'horizontal', surface = 'light', className = '' }: Props) {
  if (variant === 'icon') {
    const iconSrc = BRAND.logo.icon[surface as 'light'];
    if (iconSrc) {
      return (
        <img
          src={iconSrc}
          alt={`${BRAND.name} logo`}
          className={`h-8 w-8 shrink-0 ${className}`}
        />
      );
    }
    // No pre-baked dark-surface icon asset — fall back to an inline badge
    // rather than rendering an invisible dark-on-dark mark.
    return (
      <span
        role="img"
        aria-label={`${BRAND.name} logo`}
        className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white text-base font-bold text-ink ${className}`}
      >
        <span aria-hidden="true">F</span>
      </span>
    );
  }

  return (
    <img
      src={BRAND.logo.horizontal[surface]}
      alt={`${BRAND.name} — ${BRAND.tagline}`}
      className={`w-auto ${variant === 'compact' ? 'h-8' : 'h-[60px]'} ${className}`}
    />
  );
}
